import { FunctionComponent } from "react"

type TableMetaDataProps = {
  metaData: { label: string; value: string | number }[]
}

const TableMetaData: FunctionComponent<TableMetaDataProps> = ({ metaData }) => {
  return (
    <div className="flex flex-wrap gap-3 px-6 py-4 border-b border-gray-100">
      {metaData.map((data: { label: string; value: string | number }) => (
        <div
          key={data.label}
          className="flex items-center gap-2 px-3 py-1.5 bg-gray-50 rounded-lg text-sm"
        >
          <span className="text-gray-500">{data.label}</span>
          <span className="font-semibold text-gray-900">{data.value}</span>
        </div>
      ))}
    </div>
  )
}

export default TableMetaData
